// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-container-edf2e{background:#e5f9f9;border:.02rem solid rgba(0,200,200,.5);border-radius:.24rem;box-sizing:content-box;color:#00c8c8;font-family:PingFangSC-Regular;font-size:.36rem;letter-spacing:0;line-height:.48rem;margin-left:.18rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "icon-container-edf2e"
};
export default ___CSS_LOADER_EXPORT___;
